import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { NavController } from '@ionic/angular/standalone';
import { AuthService } from '@services/auth.service';
import { of, switchMap } from 'rxjs';

export const authGuard: CanActivateFn = () => {
    const authService: AuthService = inject(AuthService);
    const navController: NavController = inject(NavController);

    return authService.checkAuthentication().pipe(
        switchMap((authenticated) => {
            // Return to login if not authenticated
            if (!authenticated) {
                navController.navigateRoot('/login');
                return of(false);
            }

            // Check if user is banned
            if (authService.user.is_banned) {
                navController.navigateRoot('/banned');
                return of(true);
            }

            // Allow the access
            return of(true);
        })
    );
};
